var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { ContentPadding } from '../../../components/base';
import { PageWrapper, PageHeader, PageContent, PageHeaderTitle, } from '../../../components/Page';
import { LinkButton } from './styles';
var PermissionDeniedContainer = function (props) { return (_jsxs(PageWrapper, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "403 Permission Denied" }), _jsx("meta", { name: "description", content: "Permission Denied" })] }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, {}) }), _jsx(PageContent, { children: _jsxs(ContentPadding, __assign({ centered: true }, { children: [_jsx("div", { children: "You dont have sufficient permission to do this action" }), _jsx(LinkButton, __assign({ onClick: props.history.goBack }, { children: "Click here to go back" }))] })) })] })); };
PermissionDeniedContainer.propTypes = {
    history: PropTypes.object,
};
export default PermissionDeniedContainer;
